import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
// core components
import DesktopHeader from "../Header/DesktopHeader";
import DesktopHeaderAdmin from "../Header/AdminHeader/DesktopHeader";
import brandTheme from "brandTheme/Theme";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { parseAndSetFlag } from "utils/Utils";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
const useStyles = makeStyles(({ theme }) => ({
  itemIcon: {
    width: "24px",
    height: "30px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: brandTheme.white,
  },
  itemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "30px",
    fontSize: "14px",
    color: brandTheme.white,
    "&:hover": {
      fontSize: "18px",
    },
  },
  sidebarWrapper: {
    position: "relative",
    width: "260px",
    height: "85vh",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#aaa",
      borderRadius: "10px",
    },
  },
  dashboardMenu: {
    backgroundColor: brandTheme.sideBarColor,
    fontWeight: "bold",
    fontFamily: brandTheme.font.poppins,
    fontSize: "18px",
    marginBottom: "8px",
        color: brandTheme.white,
    "&:hover": {
          color: brandTheme.white,
      backgroundColor: brandTheme.sideBarHoverColor,
      fontSize: "20px",
    },
  },
  item: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarColor,
    color: brandTheme.white,
    "&:focus,&:visited,&": {
      color: brandTheme.white,
    },
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
          color: brandTheme.white,
    },
  },
  activeClass: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
        color: brandTheme.white,
    backgroundColor: brandTheme.sideBarHoverColor,
  },
  children: {
    "& $activeClass": {
      paddingLeft: 35,
    },
    "& $item": {
      paddingLeft: 35,
    },
  },
}));

const SideBar = ({ handleDrawerToggle, open, checkFlagData, enabled , roleUser, designation, featureFlag}) => {
  const [itemState, setItemState] = useState({});
  const [masterOpen, setMasterOpen] = useState(true);
  const [activeLink, setActiveLink] = useState("/coreservice/core-dashboard");
  const classes = useStyles();
  const [callInProgress, setCallInProgress]=useState(false)
  const { authToken } = useSelector((state) => state.login.authData);
  const [filterMenu, setFilteredMenu]=useState([])
  useEffect(()=>{
    GetData()
  },[roleUser,designation])

  const GetData = async () => {
    setCallInProgress(true);
    const query = parseAndSetFlag(featureFlag?.showTabsAsPerTheDesignationFlag)
      ? `designation=${designation}`
      : `role=${roleUser}`;
    const result = await apiHandler({
      url: endpoint.UI_RESTRICTION_FIND + query,
      authToken: authToken,
    });
    setCallInProgress(false);
    if(result?.data?.restrictions !== null && result?.data?.restrictions !== undefined){
     const losListData = JSON.parse(result?.data?.restrictions);
     const restrictions = losListData?.los || [];
     const restrictionMap = restrictions.reduce((acc, item) => {
        acc[item.code] = item.disabled;
        return acc;
      }, {});
       const filterMenu = (items) => {
        return items
          .filter((item) => {
            const code = item.code || item.status;
            if (!code || restrictionMap[code] === undefined) {
              return true;
            }
            return restrictionMap[code] !== true;
          })
          .map((item) => {
            if (item.children) {
              const filteredChildren = filterMenu(item.children);
              if (filteredChildren.length === 0) {
                return null;
              }
              return {
                ...item,
                children: filteredChildren,
              };
            }
            return item;
          })
          .filter(Boolean);
      };
      const updatedMenu = filterMenu(checkFlagData || []);
        setFilteredMenu(updatedMenu);
    }else{
      setFilteredMenu(checkFlagData || []);
    }
  }

  const handler = (children) => {
    return children.map((subOption) => {
      // if((subOption.name === 'In Process' && (parseAndSetFlag(featureFlag.skipProcessFlag)))) return null;
      if (!subOption.children) {
        return (
          <NavLink
           to={subOption.url}
           state={{ status: subOption.status }}
            className={
              subOption.url === activeLink ? classes.activeClass : classes.item
            }
            // activeClassName="active"
            key={subOption.name}
          >
            <ListItem button>
              {typeof subOption.icon === "string" ? (
                <img
                  src={subOption.icon}
                  alt={""}
                  className={classNames(classes.itemIcon)}
                ></img>
              ) : (
                <subOption.icon className={classNames(classes.itemIcon)} />
              )}
              <ListItemText
                primary={subOption.name}
                className={classNames(classes.itemText)}
                disableTypography={true}
                onClick={() => setActiveLink(subOption.url)}
              />
            </ListItem>
          </NavLink>
        );
      }
      return (
        <div key={subOption.name}>
          <ListItem
            className={classes.dashboardMenu}
            button
            onClick={() => handleClick(subOption.name)}
          >
            {typeof subOption.icon === "string" ? (
              <img
                src={subOption.icon}
                alt={""}
                className={classNames(classes.itemIcon)}
              ></img>
            ) : (
              <subOption.icon className={classNames(classes.itemIcon)} />
            )}
            <ListItemText
              primary={subOption.name}
              disableTypography={true}
              className={classNames(classes.itemText)}
            />
            {masterOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={masterOpen} timeout="auto" className={classes.children}>
            {handler(subOption.children)}
          </Collapse>
        </div>
      );
    });
  };

  const handleClick = (item) => {
    let is = itemState;
    is[item] = !itemState[item];
    setItemState(is);
    setMasterOpen(!masterOpen);
  };
  if(callInProgress){
    return <CircularProgresss callInProgress={callInProgress} />
  }
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div className={classes.sidebarWrapper}>
            {enabled ? <DesktopHeaderAdmin /> :  <DesktopHeader />}
            {handler(filterMenu)}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <div className={classes.sidebarWrapper}>{handler(filterMenu)}</div>
      </Hidden>
    </div>
  );
};

SideBar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  open: PropTypes.bool,
};

export default SideBar;
